export default __webpack_public_path__ + "static/media/logoDaniela.55b77bb1.png";